/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import { apiPost, apiStore, generateFormData } from '../../modules/apiHelper';
import { objectIsValid, toBoolean, urlFriendly } from '../../modules/dataHelper';

export default {
  actions: {
    async getGroupTasks(context, groupId) {
      const companyId = context.rootState.user.companyid;

      const request = await apiPost('task_lists_group', generateFormData({ groupid: groupId }), 51)
        .catch((err) => {
          console.warn('getGroupTasks::task_lists_group err', err);
          return false;
        })
        .then(async (res) => {
          if (!res) return false;
          if (toBoolean(res.data.error)) return false;

          // const tasksList = _uniqBy(res.data.task_lists_group || [], 'task_name');
          const tasksList = res.data.task_lists_group || [];

          const goals = await context.dispatch('getGoals', [companyId]);

          tasksList.map((task) => {
            // eslint-disable-next-line no-param-reassign
            task.goal = goals.find((goal) => Number(goal.id) === Number(task.goalid));

            return task;
          });

          return tasksList;
        });
      //

      return request;
    },
    async getMyGroupTasks(context, groupId) {
      const userId = context.rootState.user.id;

      const request = await apiPost('task_lists_group_mentee', generateFormData({ groupid: groupId, userid: userId }), 51)
        .catch((err) => {
          console.warn('getMyGroupTasks::task_lists_group_mentee err', err);
          return false;
        })
        .then(async (res) => {
          if (!res) return false;
          if (toBoolean(res.data.error)) return false;

          // const tasksList = _uniqBy(res.data.task_lists_group_mentee || [], 'task_name');
          const tasksList = res.data.task_lists_group_mentee || [];

          const goals = await context.dispatch('getGoals', []);

          tasksList.map((task) => {
            // eslint-disable-next-line no-param-reassign
            task.goal = goals.find((goal) => Number(goal.id) === Number(task.goalid));

            // console.log(task);

            return task;
          });

          return tasksList;
        });
      //

      return request;
    },
    async getEndedGroupTasks(context, groupId) {
      const request = await apiPost('task_lists_end_group', generateFormData({ groupid: groupId }), 51)
        .catch((err) => {
          console.warn('getEndedGroupTasks::task_lists_end_group err', err);
          return false;
        })
        .then(async (res) => {
          if (!res) return false;
          if (toBoolean(res.data.error)) return false;

          const tasksList = res.data.task_lists_end_group || [];

          const goals = await context.dispatch('getGoals', []);

          tasksList.map((task) => {
            // eslint-disable-next-line no-param-reassign
            task.goal = goals.find((goal) => Number(goal.id) === Number(task.goalid));

            return task;
          });

          return tasksList;
        });
      //

      return request;
    },
    async getMyEndedGroupTasks(context, groupId) {
      const userId = context.rootState.user.id;

      const request = await apiPost('task_lists_end_group_mentee', generateFormData({ groupid: groupId, userid: userId }), 51)
        .catch((err) => {
          console.warn('getMyEndedGroupTasks::task_lists_end_group err', err);
          return false;
        })
        .then(async (res) => {
          if (!res) return false;
          if (toBoolean(res.data.error)) return false;

          const tasksList = res.data.task_lists_end_group_mentee || [];

          const goals = await context.dispatch('getGoals', []);

          tasksList.map((task) => {
            // eslint-disable-next-line no-param-reassign
            task.goal = goals.find((goal) => Number(goal.id) === Number(task.goalid));

            return task;
          });

          return tasksList;
        });
      //

      return request;
    },
    async getGroupTasksOnReview(context, groupId) {
      const request = await apiPost('task_list_review', generateFormData({
        groupid: groupId,
      }), 51)
        .catch((err) => {
          console.warn('getGroupTasksOnReview::task_list_review err', err);
          return false;
        })
        .then(async (res) => {
          if (!res) return false;
          if (toBoolean(res.data.error)) return false;

          const tasksList = res.data.task_list_review || [];

          const goals = await context.dispatch('getGoals', []);

          tasksList.map((task) => {
            // eslint-disable-next-line no-param-reassign
            task.goal = goals.find((goal) => Number(goal.id) === Number(task.goalid));

            return task;
          });

          return tasksList;
        });
      //

      return request;
    },
    async getMyGroupTasksOnReview(context, groupId) {
      const userId = context.rootState.user.id;
      const groupTasks = await context.dispatch('getGroupTasksOnReview', groupId);

      // console.log(groupTasks);

      if (Array.isArray(groupTasks)) {
        return groupTasks.filter((task) => task.menteeid == userId);
      }

      return [];
    },
    async getGroupTaskResources(context, { groupId, taskId }) {
      const formData = generateFormData({
        groupid: groupId,
        taskid: taskId,
      });

      const response = await apiPost('task_report_resource_id', formData, 51)
        .catch((err) => {
          console.warn('getGroupTaskResources::task_report_resource_id failed: ', err);
          return [];
        })
        .then(async (res) => {
          if (!res) return [];
          if (toBoolean(res.data.error)) return [];
          const resources = [];
          const resourcesProm = [];

          (res.data.task_report_resource_id || []).forEach(({
            resourceid, // resource_type,
          }) => {
            // * note: all resource_type values are 'resource'
            const r = context.dispatch('getProgramResource', [resourceid, 'resource']);

            resourcesProm.push(r);

            r.then((resource) => {
              // console.log(resource);
              if (objectIsValid(resource)) {
                resources.push(resource);
              }
            });
          });

          await Promise.all(resourcesProm);
          return resources;
        });

      return response;
    },
    async getRevertedGroupTaskResources(context, { groupId, taskId }) {
      const formData = generateFormData({
        groupid: groupId,
        taskid: taskId,
      });

      const response = await apiPost('reject_task_upload_list', formData, 56)
        .catch((err) => {
          console.warn('getRevertedGroupTaskResources::reject_task_upload_list failed: ', err);
          return [];
        })
        .then(async (res) => {
          if (!res) return [];
          if (toBoolean(res.data.error)) return [];
          const resources = [];
          const resourcesProm = [];

          (res.data.reject_task_upload_list || []).forEach(({
            resourceid,
            text,
            // taskid,
            // menteeid,
            // ...resource
          }) => {
            if (text == 1) return; // when `text` is 1, it is a text only resource. We don't need to get the resource
            const r = context.dispatch('getProgramResource', [resourceid, 'resource']);

            resourcesProm.push(r);

            r.then((resource) => {
              // console.log(resource);
              if (objectIsValid(resource)) {
                resources.push(resource);
              }
            });
          });

          await Promise.all(resourcesProm);
          return resources;
        });

      return response;
    },
    async getRevertedGroupTaskTexts(context, { groupId, taskId }) {
      const formData = generateFormData({
        groupid: groupId,
        taskid: taskId,
      });

      const response = await apiPost('reject_task_list_text', formData, 56)
        .catch((err) => {
          console.warn('getRevertedGroupTaskResources::reject_task_list_text failed: ', err);
          return [];
        })
        .then(async (res) => {
          if (!res) return [];
          if (toBoolean(res.data.error)) return [];

          // when `text` is 0, it is a file only resource. We don't need to get the resource
          return (res.data.reject_task_list_text || []).filter((text) => text.text != 0);
        });

      return response;
    },
    async getGroupTaskReportResources(context, { groupId, taskId }) {
      const formData = generateFormData({
        groupid: groupId,
        taskid: taskId,
      });

      const response = await apiPost('task_list_review_text', formData, 51)
        .catch((err) => {
          console.warn('getGroupTaskReportResources::task_list_review_text failed: ', err);
          return [];
        })
        .then(async (res) => {
          if (!res) return [];
          if (toBoolean(res.data.error)) return [];
          const resources = [];
          const resourcesProm = [];

          (res.data.task_list_review_text || []).forEach(({
            resourceid, text, // resource_type,
          }) => {
            if (text == 1) return; // when `text` is 1, it is a text only resource. We don't need to get the resource
            const r = context.dispatch('getProgramResource', [resourceid, 'resource']);

            resourcesProm.push(r);

            r.then((resource) => {
              // console.log(resource);
              if (objectIsValid(resource)) {
                resources.push(resource);
              }
            });
          });

          await Promise.all(resourcesProm);
          return resources;
        });

      return response;
    },
    async getGroupTaskReportTexts(context, { groupId, taskId }) {
      const formData = generateFormData({
        groupid: groupId,
        taskid: taskId,
      });

      const response = await apiPost('task_list_review_text', formData, 51)
        .catch((err) => {
          console.warn('getGroupTaskReportTexts::task_list_review_text failed: ', err);
          return [];
        })
        .then(async (res) => {
          if (!res) return [];
          if (toBoolean(res.data.error)) return [];

          // when `text` is 0, it is a file only resource. We don't need to get the resource
          return (res.data.task_list_review_text || []).filter((text) => text.text != 0);
        });

      return response;
    },
    async uploadGroupTaskReportResource(context, [taskid, groupid, resources = []]) {
      const requests = [];
      const percentagesComplete = [];

      Array.from(resources).forEach((resource, index) => {
        const formData = generateFormData({
          taskid,
          groupid,
          userid: context.rootState.user.id,
          name: resource.name,
        });

        formData.append('file1', resource, urlFriendly(resource.name));

        requests.push(apiPost(
          'add_task_grp_report_resource',
          formData,
          3,
          {
            'Content-Type': 'multipart/form-data',
          },
          (progressEvent) => {
            percentagesComplete[index] = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
        ));
        //
      });

      const response = Promise.all(requests)
        .catch((err) => {
          console.warn('uploadGroupTaskReportResource failed!', err);
        })
        .then((res) => {
          if (!res) return false;
          const positive = res.every((r) => !!r);
          if (!positive) return false;
          const haveErrors = res.every((r) => toBoolean(r.data.error));
          if (haveErrors) return false;

          return true;
        });
      //

      return [response, percentagesComplete];
    },
    async markGroupTaskComplete(context, [taskId, groupId, reportText = '', reportResources = []]) {
      if (!taskId) return false;
      const task = await context.dispatch('getProgramTask', [taskId]);
      const { userId } = context.getters;

      if (userId != task.menteeid) return false;

      const requests = [];
      const percentagesComplete = [];

      const arrayedResources = Array.from(reportResources);

      const uploadResource = (resource, text = '', index = 0) => {
        const formData = generateFormData({
          taskid: taskId,
          groupid: groupId,
          userid: userId,
          name: resource.name,
        });

        formData.append('file1', resource, urlFriendly(resource.name));

        if (index === 0 && text.length) {
          // resource and text report
          formData.set('text', 2);
          formData.set('review', text);
        } else {
          // resource only report
          formData.set('text', 0);
        }

        requests.push(apiPost(
          'add_task_grp_report_resource',
          formData,
          3,
          {
            'Content-Type': 'multipart/form-data',
          },
          (progressEvent) => {
            percentagesComplete[index] = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
        ));
      };

      const uploadedText = async () => {
        const formData = generateFormData({
          taskid: taskId,
          groupid: groupId,
          userid: userId,
          review: reportText,
          text: reportResources.length ? 2 : 1,
        });

        requests.push(apiPost('submit_task_report', formData, 55));
      };

      if (arrayedResources.length && reportText.length) {
        arrayedResources.forEach((resource, index) => {
          // will upload resource and text report on the first resource
          uploadResource(resource, reportText, index);
        });

        uploadedText(); // just so as to close the task reporting
      } else if (arrayedResources.length && !reportText.length) {
        arrayedResources.forEach((resource, index) => {
          uploadResource(resource, '', index);
        });
      } else if (reportText.length && !arrayedResources.length) {
        uploadedText();
      }

      const response = Promise.all(requests)
        .catch((err) => {
          console.warn('markGroupTaskComplete failed!', err);
        })
        .then(async (res) => {
          if (!res) return false;
          const positive = res.every((r) => !!r);
          if (!positive) return false;
          const haveErrors = res.every((r) => toBoolean(r.data.error));
          if (haveErrors) return false;

          // get the updated task Details
          await apiStore.removeItem(`task/${taskId}`);
          context.dispatch('getProgramTask', [taskId]);

          return true;
        });
      //

      return [response, percentagesComplete];
    },
  },
};
